import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const firstRunExperienceDialog = () => import(/* webpackChunkName: "4-feat-fre" */ './FirstRunExperienceDialog');

export default lazyLoadOnRender({ loader: firstRunExperienceDialog });
